import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppSettings } from 'src/app/enums/app-settings.enum';
import { AccountService } from 'src/app/services/account.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { ProductService } from 'src/app/services/product.service';
import { SkuDataService } from 'src/app/services/sku-data.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-subscribe',
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.scss'],
})
export class SubscribeComponent implements OnInit {
  model: NgbDateStruct;
  public sku: any;
  public agreedOnterms = false;
  public mobileNumber: any;
  public isExpended: boolean = false;
  public quantity = 1;
  autoRenew: boolean = false;
  public price: string = '';
  currentAccount: any;
  isATPostpaid: boolean;
  countries: any;
  callForwardNumber: any;
  selectedFregement: any = 0;
  sDate: any;
  start: any;
  minDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate()
  };
  end: any;
  countrycode: any;
  isBridgeSKU: boolean;
  paymentMethod: any;
  categoryDetail: any;
  addon: any;
  smilePointsOfUser: number;
  userInfo: any;
  isArabic: boolean;
  accountId: string;
  LoggedIn = false;
  isUserLoggedIn: boolean = false;
  selectedCategory: any;
  isHomeBound: boolean;
  isprimary: any;
  disabledSmilePoints: boolean = true;
  showSmilesPoints: boolean;
  allowPayWithLoyaltyPaymentMode: boolean = false;
  isControlLine: boolean = false;
  addonCMSUrl: string;
  ismobileScreen: boolean;

  reminderDateTime: any;
  reminderDate: any;
  reminderTime: any;
  reminderAmPm: any;
  timeArray:any = ['12:00','12:30','01:00','01:30','02:00','02:30','03:00','03:30','04:00','04:30','05:00','05:30','06:00'
  ,'06:30','07:00','07:30','08:00','082:30','09:00','09:30','10:00','10:30','11:00','11:30'];

  amPm:any =  ['AM', 'PM'];
  currentBalance: number;

  constructor(
    private SKUDS: SkuDataService,
    private UTS: UtilitiesService,
    private ACCS: AccountService,
    private SS: SubjectService,
    private PS: ProductService,
    private cdr: ChangeDetectorRef,
    private GAS: GoogleAnalyticsService,
    private translate: TranslateService,
    private aRoute: ActivatedRoute
  ) {
    this.SS.sku.subscribe((main) => {
      if (main && main.name && main.value) {
        this.addon = main.name;
        this.categoryDetail = main.value;
      }
    });
  }

  ngOnInit() {
    // const w = document.documentElement.clientWidth || window.innerWidth;
    // if (w < 992) {
    //   this.ismobileScreen = true;
    // } else {
    //   this.ismobileScreen = false;
    // }
    this.ismobileScreen = this.UTS.isMobileDevice();
    const locale = this.UTS.getLocaleLanguage().toLocaleLowerCase();
    if (locale == 'ar') {
      this.isArabic = true;
    } else {
      this.isArabic = false;
    }
  }
  ngDestory() {}

  ngAfterContentInit() {
    this.userInfo = this.ACCS.getUInfo();
    this.selectedCategory = this.SKUDS.getSelectedCategory();
    if (
      this.selectedCategory &&
      this.selectedCategory.categoryId &&
      this.selectedCategory.categoryId == AppSettings.HOME_BOUND
    ) {
      this.isHomeBound = true;
      this.cdr.detectChanges();
    } else {
      this.isHomeBound = false;
      this.cdr.detectChanges();
    }
    this.aRoute.queryParams.subscribe((q) => {
      if (q && q.subCategory) {
        const subCategory = q.subCategory;
        if (subCategory == AppSettings.CONTROL_LINE) {
          this.isControlLine = true;
          if (
            this.selectedCategory &&
            this.selectedCategory.categoryId &&
            this.selectedCategory.categoryId == AppSettings.HOME_BOUND
          ) {
            this.isHomeBound = true;
            this.cdr.detectChanges();
          }
        }
      }
    });
    if (this.userInfo && this.userInfo.mainServiceAccountNo) {
      this.SS.currentAccount.subscribe((r) => {
        this.currentAccount = r;
        this.isUserLoggedIn = true;
        this.mobileNumber = this.currentAccount.mobileNumber
          ? this.currentAccount.mobileNumber
          : this.currentAccount.accountNo
          ? this.currentAccount.accountNo
          : ''
          ? this.currentAccount.mobileNumber
          : '';
        this.getAccountTypeLogin();
        this.getSmilePoint();
        this.LoggedIn = true;
      });
    } else {
      this.SS.account.subscribe((r) => (this.mobileNumber = r));
      this.getAccountType();
    }
    this.SS.skuDetails.subscribe((r) => {
      if (r) {
        this.sku = { ...r, ...this.sku };
        if (this.isArabic) {
          this.addonCMSUrl = this.sku?.tAndcAcceptanceAr;
        } else {
          this.addonCMSUrl = this.sku?.tAndcAcceptanceEn;
        }
        this.cdr.detectChanges();
      }
      if (this.sku && this.sku.listPrice) {
        this.getPrice();
      }
      if (
        (this.sku && this.sku.skuId == AppSettings.ETISALAT_EBRIDGE_LITE) ||
        this.sku.skuId == AppSettings.ETISALAT_EBRIDGE_PREIMUM
      ) {
        this.isBridgeSKU = true;
        this.getCountries();
      } else {
        this.isBridgeSKU = false;
      }
      if (this.sku && this.sku.allowPayWithLoyaltyPaymentMode) {
        this.allowPayWithLoyaltyPaymentMode = true;
      }
    });
  }

  increase() {
    if (this.sku && this.sku.maxQuantity) {
      if (this.sku.maxQuantity > this.quantity) {
        this.quantity++;
        this.getPrice();
      }
    }
  }

  decrease() {
    if (this.sku && this.sku.maxQuantity) {
      if (this.quantity > 1) {
        this.quantity--;
        this.getPrice();
      }
    }
  }

  changeToggle(e: any) {
    this.autoRenew = !this.autoRenew;
  }

  subscribeAddon() {
    const userInfo: any = this.ACCS.getUInfo();
    if (userInfo && userInfo.mainServiceAccountNo) {
      this.addAddon();
    } else {
      this.addAddon();
    }
  }
  selectTime(time: any) {
    this.reminderTime = time;
  }
  selectAmPm(amPm: any) {
    this.reminderAmPm = amPm;
  }
  addAddon() {
    this.UTS.clearError();
    let link = '/addAddons';
    if (this.paymentMethod == 2) {
      if (parseInt(this.price) > this.smilePointsOfUser) {
        this.UTS.error('Error! Not Enough Smile Points');
        return;
      }
    }
    let specialInput = []; //this.sku.specialInput ? this.sku.specialInput :
    const payload = {
      accountNo: this.mobileNumber,
      accountNumber: null,
      addonId: this.sku.skuId,
      skuid: null,
      validate: false,
      type: this.autoRenew == true ? 'AUTO_RENEWAL' : 'ONE_TIME',
      quantity: this.quantity,
      specialInputs: specialInput,
      locale: this.UTS.getLocaleLanguage().toString().toLocaleUpperCase(),
      forwardCountryCode: null,
      forwardCountryNumber: null,
      reminder_date_time: null,
    };
    if (payload['preferredNumbers']) {
      delete payload['preferredNumbers'];
    }
    if (this.paymentMethod == 2) {
      payload['paymentMethod'] = 'loyalty';
    }
    this.addonToCart();
    if (this.LoggedIn) {
      payload.accountNo = this.accountId;
      payload['preferredNumbers'] = this.mobileNumber;
      link = '/addAddonsLoggedIn';
    }
    if (this.sku && this.sku.productType == 'BRIDGE_ADDON') {
      if (this.selectedFregement == 0) {
        payload.forwardCountryCode = this.countrycode;
        payload.forwardCountryNumber = this.callForwardNumber.replace(
          this.countrycode,
          ''
        );

        let specialForwardCountryCodeObject = {
          fieldName: 'forward_country_code',
          fieldValue: payload.forwardCountryCode,
        };
        let specialForwardCountryNumberObject = {
          fieldName: 'forward_country_number',
          fieldValue: payload.forwardCountryNumber,
        };
        payload.specialInputs.push(specialForwardCountryCodeObject);
        payload.specialInputs.push(specialForwardCountryNumberObject);
      } else {
        let [hours, minutes] = this.reminderTime.split(":");
        if (hours == "12") {
          hours = "00";
        }

        if (this.reminderAmPm == "PM") {
          hours = parseInt(hours, 10) + 12;
        }

        let time  = hours+":"+minutes+":00";
        let date  = this.reminderDate.day+"/"+(this.reminderDate.month-1)+"/"+this.reminderDate.year;

        this.reminderDateTime = date +" "+ time;

        payload.reminder_date_time = this.reminderDateTime;
        let specialReminderDateTimeObject = {
          fieldName: 'reminder_date_time',
          fieldValue: payload.reminder_date_time,
        };
        payload.specialInputs.push(specialReminderDateTimeObject);
      }

      if (this.LoggedIn) {
        link = '/addAddOn';
        payload.skuid = this.sku.skuId;
        payload.accountNumber = this.accountId;
      }

      this.SKUDS.addAddons(payload, link).subscribe(
        (r: any) => {
          if (r) {
            if (r.success == true || r.success == 'true') {
              this.purchase(r.transactionNo, this.price);
              this.SS.addonBuySuccessfully.next({
                success: true,
                mobileNumber: this.mobileNumber,
                price: this.price,
                billType: this.isATPostpaid
                  ? 1
                  : this.paymentMethod && this.paymentMethod == 2
                  ? 2
                  : 3,
                data: r,
                addonType: this.sku.productType,
              });
              this.cdr.detectChanges();
            } else if (r.reason) {
              this.UTS.error(r.reason);
            } else {
              this.UTS.error(AppSettings.ERROR);
            }
          }
        },
        (e) => {
          let eMessage = '';
          if (this.UTS.getLocaleLanguage() == 'en') {
            if (
              e.error.errorDescription == AppSettings.ERROR_VAL_00015 ||
              e.error.errorDescription == AppSettings.ECARE_ERROR_VAL_00015
            ) {
              this.translate.get('ERROR_VAL_00015').subscribe((message) => {
                //   this.UTS.error(message);
                eMessage = message;
              });
            } else if (
              e.error.errorDescription == AppSettings.ERROR_VAL_00305
            ) {
              this.translate.get('ERROR_VAL_00305').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e.error.errorDescription == AppSettings.ERROR_VAL_00167
            ) {
              this.translate.get('ERROR_VAL_00167').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e.error.errorDescription == AppSettings.ERROR_VAL_00303
            ) {
              this.translate.get('ERROR_VAL_00303').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e.error.errorDescription == AppSettings.ERROR_CBCM_00002 ||
              e.error.errorDescription == AppSettings.ERROR_VAL_00180
            ) {
              this.translate.get('ERROR_CBCM_00002').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e.error.errorDescription == AppSettings.ERROR_VAL_00227
            ) {
              this.translate.get('ERROR_VAL_00227').subscribe((message) => {
                eMessage = message;
              });
            } else if (e.error.errorDescription == AppSettings.ERROR_IN_00002) {
              this.translate.get('ERROR_IN_00002').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e.error.errorDescription == AppSettings.ERROR_VAL_00011 ||
              e.error.message == AppSettings.ERROR_VAL_00011 ||
              e.error.message == AppSettings.ERROR_VAL_00002 ||
              e.error.errorDescription == AppSettings.ERROR_VAL_00002
            ) {
              this.translate.get('ERROR_VAL_00011').subscribe((message) => {
                eMessage = message;
              });
            }
            else if (
              ( e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00011)) ||
              ( e.error && e.error.message && e.error.message.includes(AppSettings.VAL_00011)) ||
              ( e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_EAQTY)) ||
              ( e.error && e.error.message && e.error.message.includes(AppSettings.VAL_EAQTY)) ||
              ( e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00061)) ||
              ( e.error && e.error.message && e.error.message.includes(AppSettings.VAL_00061)) ||
              ( e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00133)) ||
              ( e.error && e.error.message && e.error.message.includes(AppSettings.VAL_00133)) ||
              ( e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00013)) ||
              ( e.error && e.error.message && e.error.message.includes(AppSettings.VAL_00013))
            ) {
              this.translate.get('ERROR_VAL_00011').subscribe((message) => {
                eMessage = message;
              });
            } else {
              eMessage = e.error.errorDescription;
              //   this.UTS.error(e.error.errorDescription);
            }
          } else {
            if (
              e.error.errorDescription == AppSettings.ERROR_VAL_00015 ||
              e.error.errorDescription == AppSettings.ECARE_ERROR_VAL_00015
            ) {
              this.translate.get('ERROR_VAL_00015').subscribe((message) => {
                //   this.UTS.error(message);
                eMessage = message;
              });
            } else if (
              e.error.errorDescription == AppSettings.ERROR_VAL_00305
            ) {
              this.translate.get('ERROR_VAL_00305').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e.error.errorDescription == AppSettings.ERROR_VAL_00167
            ) {
              this.translate.get('ERROR_VAL_00167').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e.error.errorDescription == AppSettings.ERROR_VAL_00303
            ) {
              this.translate.get('ERROR_VAL_00303').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e.error.errorDescription == AppSettings.ERROR_VAL_00227
            ) {
              this.translate.get('ERROR_VAL_00227').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e.error.errorDescription == AppSettings.ERROR_CBCM_00002 ||
              e.error.errorDescription == AppSettings.ERROR_VAL_00180
            ) {
              this.translate.get('ERROR_CBCM_00002').subscribe((message) => {
                eMessage = message;
              });
            } else if (e.error.errorDescription == AppSettings.ERROR_IN_00002) {
              this.translate.get('ERROR_IN_00002').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e.error.errorDescription == AppSettings.ERROR_VAL_00011 ||
              e.error.message == AppSettings.ERROR_VAL_00011 ||
              e.error.message == AppSettings.ERROR_VAL_00002 ||
              e.error.errorDescription == AppSettings.ERROR_VAL_00002
            ) {
              this.translate.get('ERROR_VAL_00011').subscribe((message) => {
                eMessage = message;
              });
            }
            else if (
              (e.error && e.error.errorDescription &&  e.error.errorDescription.includes(AppSettings.VAL_00011)) ||
              (e.error && e.error.message &&  e.error.message.includes(AppSettings.VAL_00011)) ||
              (e.error && e.error.errorDescription &&  e.error.errorDescription.includes(AppSettings.VAL_EAQTY)) ||
              (e.error && e.error.message &&  e.error.message.includes(AppSettings.VAL_EAQTY)) ||
              (e.error && e.error.errorDescription &&  e.error.errorDescription.includes(AppSettings.VAL_00061)) ||
              (e.error && e.error.message &&  e.error.message.includes(AppSettings.VAL_00061)) ||
              (e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00133)) ||
              (e.error && e.error.message && e.error.message.includes(AppSettings.VAL_00133)) ||
              (e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00013)) ||
              (e.error && e.error.message && e.error.message.includes(AppSettings.VAL_00013))
            ) {
              this.translate.get('ERROR_VAL_00011').subscribe((message) => {
                eMessage = message;
              });
            }
             else {
              eMessage = e.error.errorDescriptionAr;
              //   this.UTS.error(e.error.errorDescriptionAr);
            }
          }
          this.SS.addonBuyError.next(eMessage);
          this.SS.addonBuySuccessfully.next({ success: false, data: e });
        }
      );
    } else {
      this.SKUDS.addAddons(payload, link).subscribe(
        (r: any) => {
          if (r) {
            if (r.success == true || r.success == 'true') {
              this.purchase(r.transactionNo, this.price);
              this.SS.addonBuySuccessfully.next({
                success: true,
                mobileNumber: this.mobileNumber,
                price: this.price,
                billType: this.isATPostpaid
                  ? 1
                  : this.paymentMethod && this.paymentMethod == 2
                  ? 2
                  : 3,
                data: r,
              });
              this.cdr.detectChanges();
            } else if (r.reason) {
              this.UTS.error(r.reason);
            } else {
              this.UTS.error(AppSettings.ERROR);
            }
          }
        },
        (e) => {
          let eMessage = '';
          if (this.UTS.getLocaleLanguage() == 'en') {
            if (
              e.error.errorDescription == AppSettings.ERROR_RTF_VAL_00015 ||
              e.error.errorDescription == AppSettings.ERROR_VAL_00015
            ) {
              this.translate.get('ERROR_VAL_00015').subscribe((message) => {
                //   this.UTS.error(message);
                eMessage = message;
              });
            } 
            else if (
              e.error.errorDescription == AppSettings.ERROR_VAL_00011 ||
              e.error.message == AppSettings.ERROR_VAL_00011 ||
              e.error.message == AppSettings.ERROR_VAL_00002 ||
              e.error.errorDescription == AppSettings.ERROR_VAL_00002
            ) {
              this.translate.get('ERROR_VAL_00011').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              (e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00011)) ||
              (e.error && e.error.message && e.error.message.includes(AppSettings.VAL_00011)) ||
              (e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_EAQTY)) ||
              (e.error && e.error.message && e.error.message.includes(AppSettings.VAL_EAQTY)) ||
              (e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00061)) ||
              (e.error && e.error.message && e.error.message.includes(AppSettings.VAL_00061)) ||
              (e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00133)) ||
              (e.error && e.error.message && e.error.message.includes(AppSettings.VAL_00133)) ||
              (e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00013)) ||
              (e.error && e.error.message && e.error.message.includes(AppSettings.VAL_00013))
            ) {
              this.translate.get('ERROR_VAL_00011').subscribe((message) => {
                eMessage = message;
              });
            }
            else {
              eMessage = e.error.errorDescription;
              //   this.UTS.error(e.error.errorDescription);
            }
          } else {
            if (e.error.errorDescription == AppSettings.ERROR_VAL_00015) {
              this.translate.get('ERROR_VAL_00015').subscribe((message) => {
                //  this.UTS.error(message);
                eMessage = message;
              });
            }
            else if (
              e.error.errorDescription == AppSettings.ERROR_VAL_00011 ||
              e.error.message == AppSettings.ERROR_VAL_00011 ||
              e.error.message == AppSettings.ERROR_VAL_00002 ||
              e.error.errorDescription == AppSettings.ERROR_VAL_00002
            ) {
              this.translate.get('ERROR_VAL_00011').subscribe((message) => {
                eMessage = message;
              });
            }
            else if (
              ( e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00011)) ||
              ( e.error && e.error.message &&  e.error.message.includes(AppSettings.VAL_00011)) ||
              ( e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_EAQTY)) ||
              ( e.error && e.error.message && e.error.message.includes(AppSettings.VAL_EAQTY)) ||
              ( e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00061)) ||
              ( e.error && e.error.message && e.error.message.includes(AppSettings.VAL_00061)) ||
              ( e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00133)) ||
              ( e.error && e.error.message && e.error.message.includes(AppSettings.VAL_00133)) ||
              ( e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00013)) ||
              ( e.error && e.error.message &&  e.error.message.includes(AppSettings.VAL_00013))
            ) {
              this.translate.get('ERROR_VAL_00011').subscribe((message) => {
                eMessage = message;
              });
            }  else {
              eMessage = e.error.errorDescriptionAr;
              //   this.UTS.error(e.error.errorDescriptionAr);
            }
          }
          this.SS.addonBuyError.next(eMessage);
          this.SS.addonBuySuccessfully.next({ success: false, data: e });
        }
      );
    }
  }

  getPrice() {
    this.price = Number(
      this.sku.listPrice && this.parsePrice(this.sku.listPrice) > 0
        ? this.sku.listPrice
        : this.sku.recurringPrice &&
          this.parsePrice(this.sku.recurringPrice) > 0
        ? this.sku.recurringPrice
        : '0'
    ).toFixed(2);

    // this.price = Number(Number(this.sku.listPrice) * this.quantity).toFixed(2);
    this.cdr.detectChanges();
  }

  agreeToggle() {
    this.agreedOnterms = !this.agreedOnterms;
    this.cdr.detectChanges();
  }

  agreeToggleLastExist() {
    setTimeout(() => {
      this.isExpended = !this.isExpended;
      this.cdr.detectChanges();
    }, 800);
  }

  getAccountType() {
    this.PS.getAccountType(this.mobileNumber).subscribe(
      (res: any) => {
        if (res && res.accountType) {
          this.accountId = res.accountId;
          if (res.accountType.toLowerCase() == 'postpaid') {
            this.isATPostpaid = true;
          } else {
            this.isATPostpaid = false;
          }
        } else {
          this.isATPostpaid = false;
        }
        this.checkControlline();
      },
      (e) => {
        this.UTS.log(e);
        this.checkControlline();
      }
    );
  }

  getAccountTypeLogin() {
    if (this.currentAccount && this.currentAccount.accountType == 'POSTPAID') {
      this.isATPostpaid = true;
    } else {
      this.isATPostpaid = false;
    }
    this.checkControlline();
  }

  checkControlline() {
    this.aRoute.queryParams.subscribe((q) => {
      if (q && q.subCategory) {
        const subCategory = q.subCategory;
        if (subCategory == AppSettings.CONTROL_LINE) {
          this.isControlLine = true;
          this.isATPostpaid = false;
        }
      }
      setTimeout(() => {
        if (this.sku.displayName.includes('Control Line')) {
          this.isControlLine = true;
          this.isATPostpaid = false;
        }
      }, 500);
    });
  }
  getCountries() {
    this.PS.getCountries(this.sku.skuId).subscribe(
      (res: any) => {
        if (res) {
          this.countries = res.countries;
          this.loadFlags();
        }
      },
      (e) => this.UTS.log(e)
    );
  }

  segmentChanged(val) {
    this.selectedFregement = val
  }

  chooseCountry(e) {
    this.countrycode = e.code;
  }

  loadFlags() {
    setTimeout(() => {
      let radios = document.getElementsByClassName('alert-radio-label');
      for (let index = 1; index < radios.length; index++) {
        let element = radios[index];
        element.innerHTML = element.innerHTML.concat(
          '<img class="country-image" style="width: 30px;height:16px;" src="' +
            this.countries[index - 1].flag +
            '" />'
        );
      }
    }, 2000);
  }

  addPaymentMethod(e) {
    this.paymentMethod = e.target.value;
  }

  addonToCart() {
    if (
      this.categoryDetail &&
      this.addon &&
      (this.categoryDetail.categoryTitle ||
        this.categoryDetail.currentCategory) &&
      this.sku &&
      this.sku.displayName &&
      (this.sku.id || this.sku.skuId) &&
      this.sku.listPrice
    ) {
      this.GAS.addToCart(
        this.addon,
        this.categoryDetail.categoryTitle
          ? this.categoryDetail.categoryTitle
          : this.categoryDetail.currentCategory,
        this.sku.displayName,
        this.sku.id ? this.sku.id : this.sku.skuId ? this.sku.skuId : '',
        this.sku.listPrice,
        this.quantity,
        this.sku.brand
      );
    }
  }
  private purchase(TID, R) {
    if (
      this.categoryDetail &&
      this.addon &&
      (this.categoryDetail.categoryTitle ||
        this.categoryDetail.currentCategory) &&
      this.sku &&
      this.sku.displayName &&
      (this.sku.id || this.sku.skuId) &&
      this.sku.listPrice
    ) {
      this.GAS.purchase(
        this.addon,
        this.categoryDetail.categoryTitle
          ? this.categoryDetail.categoryTitle
          : this.categoryDetail.currentCategory,
        this.sku.displayName,
        this.sku.id ? this.sku.id : this.sku.skuId ? this.sku.skuId : '',
        this.sku.listPrice,
        this.quantity,
        this.sku.brand,
        TID ? TID : '',
        R
      );
    }
  }

  parsePrice(v) {
    if (Number(v)) {
      return Number(v);
    }
    return v;
  }

  getSmilePoint() {
    if (this.userInfo) {
      this.accountId = this.currentAccount.accountId;
      this.PS.getAccountSummary(this.accountId).subscribe((resp: any) => {
        if (resp && resp.userAccount) {
          // if(resp.userAccount.accountSmilesPoints || resp.userAccount.accountSmilesPoints > -1){
          this.smilePointsOfUser = Number(resp.userAccount.accountSmilesPoints);
          if(resp.userAccount.currentBalance && Number(resp.userAccount.currentBalance) > 0){
          this.currentBalance = Number(resp.userAccount.currentBalance);
          }
          else{
            this.currentBalance = 0;
          }
          this.showSmilesPoints = true;
          if (
            this.sku &&
            this.sku.smilesPoints &&
            this.smilePointsOfUser > this.sku.smilesPoints
          ) {
            this.disabledSmilePoints = false;
          }
          //  }
          if (resp.userAccount.accountSmilesPoints) {
            this.isprimary = resp.userAccount.primary;
          }
        }
      });
    }
  }
}
